import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import { CommonModule } from '@angular/common';
import {CommonWidgetDirective} from "@wms/directives";
import {FormsModule} from "@angular/forms";
import {TypeaheadModule} from "ngx-bootstrap/typeahead";
import {BaseComponent} from "@wms/components";
import {getClonedObject} from "@wm/core";
import {includes, startsWith} from "lodash-es";

@Component({
  selector: 'wms-combo-box',
  standalone: true,
  imports: [CommonModule, CommonWidgetDirective, FormsModule, TypeaheadModule],
  templateUrl: './wms-combo-box.component.html',
  styleUrls: ['./wms-combo-box.component.less']
})
export class WmsComboBoxComponent extends BaseComponent implements OnDestroy {
  @Input() id: string;
  @Input() options: any;
  @Input() model: any;
  @Input() optionKey: string;
  @Input() subOptionkey: string;
  @Input() customClass: string;
  @Input() message: string;

  @Output() onSelect = new EventEmitter<any>();
  @Output() onClear = new EventEmitter<any>();

  openDD: boolean;
  hasResults: boolean;
  documentClickSubscription: any;
  constructor() {
    super();
    this.openDD     = false;
    this.hasResults = true;
    this.documentClickSubscription = this.eventManager.documentClickObservable().subscribe((target: any) => {
      let element = document.getElementById(this.id);
      if((!element || !element.contains(target)) && !target.id.endsWith(this.id)){
        this.openDD = false;
      }});
  }

  ngOnChanges() {
    this.options.forEach((option: any) => {
      option.filteredOptions = getClonedObject(option.data);
    });
  }
  textInputFocussed() {
    this.openDD = !this.openDD;
  }

  handleSelect(option: any) {
    this.openDD = !this.openDD;
    this.onSelect.emit(option);
  }

  handleClear() {
    this.options.forEach((option: any) => {
      option.filteredOptions = getClonedObject(option.data);
    });
    this.hasResults = true;
    this.model      = null;
    this.onClear.emit();
  }

  searchOptionsByInput() {
    if(this.model === '') {
      this.handleClear();
    } else {
      this.openDD = true;
      let hasResults: boolean[] = [];
      this.options.forEach((option: any) => {
        option.filteredOptions = option.data.filter((obj: any) => {
          return startsWith(obj[this.optionKey], this.model)
        });
        hasResults.push(option.filteredOptions.length ? true : false);
        this.hasResults = includes(hasResults, true);
      });
    }
  }

  override ngOnDestroy() {
    super.ngOnDestroy();
    if(this.documentClickSubscription)
      this.documentClickSubscription.unsubscribe();
  }
}
